import { HeadTitle, MenuItem, Spacer, Bottomsheet, Button, Icon, Tsmbd22, Trg16, Trg12 } from 'oui';
import {SideBox, DefaultBox, VisualBox, FlexBox} from '../../etc/LBox/LBox';
import { useOutletContext } from 'react-router-dom';
import { useMtgPurpose } from '../../../application/bloc/useMtgPurpose';
import {useState} from "react";
import doc from '../../../assets/images/feature/feature-mtg-visual4.png'

export const MtgPurpose = () => {
  const {
    mappedCodeList,
    navigateNextStep,
    mortgageInfo,
    onChangeWrappingInput,
    saveInputInfoTemp,
  }: any = useOutletContext();

  const { sendBeaconClkBtnOption } = useMtgPurpose();

  const [isOpen, setOpen] = useState<boolean>(false);
  const onClickMenuItem = (e: any) => {
    sendBeaconClkBtnOption({
      btmsheet_name: '',
      option_name: e.text,
      before_option_name: mortgageInfo.purposeCd.text,
    });
    onChangeWrappingInput({ key: 'purposeCd', text: e.text, value: e.value });
    saveInputInfoTemp();
    if(e.value === '30'){
      setOpen(true);
      return;
    }
    navigateNextStep('PUSH');
  };

  return (
    <>
      <HeadTitle textTitle={'대출 목적을 선택해 주세요'} />
      <Spacer size={'sm'} />
      <SideBox>
        {mappedCodeList?.C048?.map((item: any) => {
          return (
            <MenuItem
              key={item.text}
              text={item.text}
              value={item.value}
              isSelected={mortgageInfo.purposeCd.value === item.value}
              subText={item.text !== item.desc && item.desc}
              state={
                mortgageInfo.purposeCd.value === item.value
                  ? 'focused'
                  : 'enabled'
              }
              onSelectMenuItem={() => {}}
              onClickMenuItem={() => onClickMenuItem(item)}
            />
          );
        })}
      </SideBox>

      <Bottomsheet
          backdrop={true}
          isOpen={isOpen}
          isMaxHeight={false}
          onClose={() => setOpen(false)}
          children={
            <div style={{textAlign: "center"}}>
                <div style={{float: "right", padding:'0 20px 0'}} onClick={() => setOpen(false)}>
                    <Icon name={'CloseSharp'}/>
                </div>
                <VisualBox>
                    <img src={doc} alt={'doc'} />
                </VisualBox>
                <Tsmbd22 text={'사업 자금'} /><br/>
                <Spacer size={'xs'}/>
                <Trg16 color={'#696969'} text={'LTV 70%이상의 한도로 대출을 받아'} /><br/>
                <Trg16 color={'#696969'} text={'사업 자금에 활용하실 분들에게 적합해요'} /><br/>
                <Spacer size={'xs'}/>
                <Trg12 color={'#9C9C9C'} text={'* 임대·법인사업자는 사업 자금 대출이 어려워요'} />
              <DefaultBox>
                  <Button configuration={"contained"} flexible={true} children={'다음'} onClick={() => navigateNextStep('PUSH')} />
              </DefaultBox>
            </div>
          }
      />
    </>
  );
};
